import {
  UMLAUTS_REGEX,
} from "@/scripts/Constants";

const countCharacterSepaField = (value: string) => {
    if(value === undefined || value === null) return 0;
    if(typeof value !== "string") return Number.NaN;

    return value.replace(UMLAUTS_REGEX, 'aa').length;
}

export {
  countCharacterSepaField,
}
